import React, { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../../helpers/indexedDbHelper';
import LayoutContent from '../../../components/layouts/content2';
import { Link } from 'react-router-dom';
import { useRefresh } from '../../../hooks/useRefresh';
import {useTranslation} from 'react-i18next';
import translate from '../../../helpers/translate';
import translateMenu from '../../../helpers/translateMenu';

function Index() {
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const location = useLocation();
    const { dish, alldish, currentDish } = location.state || {};

    const [dataDish, setDataDish] = useState(dish);
    const [dataDesserts, setDataDesserts] = useState(false);
    const [dataDrinks, setDataDrinks] = useState(false);

    const [image, setImage] = useState(false);


    const {change} = useRefresh();
    const [menus, setMenus] = useState([]);

    useEffect(() => {
        console.log('entro aca en')
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, [change]);
    
    
    useEffect(() => {
        fetchImage(`menu-image-h-${dataDish.id}`).then((url) => {
            if (url) {
                setImage(url);
            }
        });

    }, [dataDish]);


     useEffect(() => {
        menus.map((item) => {
        if (item.name === 'Desserts') {
            setDataDesserts(item);
        }

        if (item.name === 'Soft Drinks') {
            setDataDrinks(item);
        }
        });
    }, [menus]);

    


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const navDish = (position) => {
        const menuIndex = alldish.findIndex(item => item === dataDish);

        let newIndex;
        if (position === 1) {
        newIndex = (menuIndex + 1) % alldish.length;
        } else if (position === -1) {
        newIndex = (menuIndex - 1 + alldish.length) % alldish.length;
        } else {
        return;
        }
        const newDish = alldish[newIndex];
        setDataDish(newDish);
    };

    
    return (
          <LayoutContent showBack={false} showLogo={false}>
            <div style={{padding: '10px 20px',}}>
                 <img src={image} style={{  width: '100%',
                            height: 408, borderRadius: 10 }} />
                <br />

                <div style={{
                    marginTop: 5,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    display: 'flex'
                }}>

                    <div style={{
                        fontFamily: "LondrinaSolidRegular",
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '80%'
                     }}>
                    <p className='shor-text-one' style={{fontSize: 32, color: 'white', fontWeight: "900", textAlign: 'left'}}>
                      {langEng ? dataDish.name : translate(i18n.language, dataDish.language, dataDish.name)}
                    </p>
                  </div>
                    

                    <div style={{
                        display: 'flex',
                      flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginRight: 10,
                  }}>
                    <p style={{fontSize: 30, color: 'white', fontWeight: "900", fontFamily: "LondrinaSolidRegular",}}>
                      $ {dataDish.price.toFixed(2)}
                    </p>
                  </div>
                </div>
                
                <div>
                    <p
                        lineBreakMode="tail"
                        className='shor-text-five'
                      numberOfLines={5}
                      style={{fontSize: 22, textAlign:'left', color: 'white', fontFamily: "LondrinaSolidLight",}}>
                     {langEng ? 
                                    `${dataDish.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    dataDish.language, 
                                    dataDish.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                    </p>
                </div>


                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        marginBottom: 10,
                        marginTop: 10
                    }}>
                        <img
                            style={{
                            width: '40%',
                            height: 20,
                            }}
                            src={require('./assets/brand.png')}
                        />
                        <p
                        style={{
                        alignSelf: 'center',
                        fontSize: 24,
                            textTransform: 'uppercase',
                            color: 'white',
                            fontWeight: '900',
                        fontFamily: "LondrinaSolidRegular",
                        
                    }}>
                    ¡NO OLVIDES!
                    </p>
                    <img
                        style={{
                        width: '40%',
                        height: 20,
                        }}
                        src={require('./assets/brand.png')}
                    />
                </div>
                <br/>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}>
                    <Link to="/MenuList" state={{ dishs: dataDrinks }}>
                        <img
                        src={require('./assets/App-26.png')}
                        resizeMode={'cover'}
                        style={{
                             width: 330,
                            height: 300,
                            borderRadius: 14,
                            marginBottom: 10,
                            objectFit: 'cover',
                            boderRadius: 20,
                        }}
                        />
                    </Link>

                   <Link to="/MenuList" state={{ dishs: dataDesserts }}>
                        <img
                            src={require('./assets/App-27.png')}
                            resizeMode={'cover'}
                        style={{
                             width: 330,
                            height: 300,
                            borderRadius: 14,
                            marginBottom: 10,
                            objectFit: 'cover',
                            boderRadius: 20,
                        }}
                        />
                    </Link>
                </div>

                <br />

                <div style={{
                    marginBottom: 5,
                    display: 'flex',
                    zIndex: 999,
                    alignSelf: 'center',
                    width: '100%',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div style={{
                         width: '30%',
                        textAlign: 'center',
                    }}
                    onClick={()=> navDish(-1)}
                    >
                        <div
                            style={{
                                 borderRadius: 5,
                                justifyContent: 'center',
                                backgroundColor: '#f0a63d',
                                padding: 5,
                                 flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-around',
                                background: 'white',
                                display: 'flex'
                            }}
                        >
                        <div
                            style={{
                            padding: 10,
                            paddingVertical: 5,
                            width: '100%',
                            borderColor: '#b8272e',
                            borderWidth: 2,
                                    alignItems: 'center',
                            borderStyle: 'solid'
                                }}>
                                
                               <img src={require('./assets/left.png')} />
                           
                        </div>
                        </div>
                    </div>

                    <div style={{
                         width: '30%',
                            textAlign: 'center',
                    }}>
                        <div
                            style={{
                             borderRadius: 5,
                            justifyContent: 'center',
                            backgroundColor: '#f0a63d',
                                padding: 5,
                             display: 'flex'
                        }}
                        >
                            <Link
                                to="/MenuList"
                                state={{ dishs: currentDish }}
                                style={{
                                padding: 10,
                                paddingVertical: 3,
                                width: '100%',
                                borderColor: '#b8272e',
                                        borderWidth: 2,
                                    borderStyle: 'solid',
                                textDecoration: 'none'
                            }}>
                                    <p style={{
                                        textAlign: 'center',
                                        color: 'black',
                                        textTransform: 'uppercase',
                                        fontSize: 23,
                                    fontWeight: '900',
                                        fontFamily: "LondrinaSolidRegular",
                                }}>
                                    {langEng ? " Go Back":  "Ir Atras"}
                                       
                                    </p>
                            </Link>
                        </div>
                    </div>

                    <div style={{ width: '30%',
                        textAlign: 'center'
                    }}
                        onClick={()=> navDish(1)}
                    >
                        <div
                            style={{
                             borderRadius: 5,
                                justifyContent: 'center',
                                backgroundColor: '#f0a63d',
                                padding: 5,
                                 flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'space-around',
                                background: 'white',
                                 display: 'flex'
                        }}
                       >
                        <div
                            style={{
                            padding: 10,
                            paddingVertical: 5,
                            width: '100%',
                            borderColor: '#b8272e',
                            borderWidth: 2,
                                    alignItems: 'center',
                            borderStyle: 'solid'
                            }}>
                            <img src={require('./assets/right.png')} />
                        </div>
                        </div>
                    </div>
                    </div>
           </div>
        </LayoutContent>
    );
}

export default Index;